import BuildingType from '@/roc/building/BuildingType';
import Effects from '@/roc/effects/Effects';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import PassiveAura from '@/roc/effects/PassiveAura/PassiveAura';
import PassiveAuraType from '@/roc/effects/PassiveAura/PassiveAuraType';
import EffectAmount from '@/roc/effects/EffectAmount';
import PassiveProduction from '@/roc/effects/Production/PassiveProduction';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';

const AncientLibrary = {
  id: '80',
  name: "Ancient Library",
  width: 4,
  height: 3,
  type: BuildingType.EVENT,
  era: 'stoneAge',
  icon: 'Ancient_Library',
  minLevel: 1,
  maxLevel: 60,
  url: 'https://riseofcultures.wiki.gg/wiki/Buildings/Ancient_Library',
  flags: 0,
  counts: null,
  effects: Effects.create([
    new PassiveAura(
      PassiveAuraType.HEAVY_INFANTRY_DAMAGE_MOD,
      EffectAmount.asPerLevel([
        0.5, 0.5, 0.5, 0.8, 0.8, 1.0, 1.0, 1.0, 1.3, 1.3,
        1.5, 1.5, 1.5, 1.8, 1.8, 2.0, 2.0, 2.0, 2.3, 2.3,
        2.5, 2.5, 2.5, 2.8, 2.8, 3.0, 3.0, 3.0, 3.3, 3.3,
        3.5, 3.5, 3.5, 3.8, 3.8, 4.0, 4.0, 4.0, 4.3, 4.3,
        4.5, 4.5, 4.5, 4.8, 4.8, 5.0, 5.0, 5.0, 5.3, 5.3,
        5.5, 5.5, 5.5, 5.8, 5.8, 6.0, 6.0, 6.0, 6.3, 6.3,
      ]),
      '%'
    ),
    new PassiveAura(
      PassiveAuraType.GRANTS_CAPITAL_CITY_WORKER,
      EffectAmount.asPerLevel([
        1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
        2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2,
        3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,
        4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4,
        5,
      ]),
    ),
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput.asPerEraAndLevel({
        stoneAge: [
          0,100,105,110,115,120,125,130,135,140,145,150,155,160,165,170,175,180,185,190,195,200,205,210,215,220,225,230,235,240,245,250,255,260,265,270,275,280,285,290,295,300,305,310,315,320,325,330,335,340,345,350,355,360,365,370,375,380,385,390
        ],
        bronzeAge: [
          0,110,116,122,128,134,140,146,152,158,164,170,176,182,188,194,200,206,212,218,224,230,236,242,248,254,260,266,272,278,284,290,296,302,308,314,320,326,332,338,344,350,356,362,368,374,380,386,392,398,404,410,416,422,428,434,440,446,452,458
        ],
        minoanEra: [
          0,120,127,134,141,148,155,162,169,176,183,190,197,204,211,218,225,232,239,246,253,260,267,274,281,288,295,302,309,316,323,330,337,344,351,358,365,372,379,386,393,400,407,414,421,428,435,442,449,456,463,470,477,484,491,498,505,512,519,526
        ],
        classicGreece: [
          0,130,138,146,154,162,170,178,186,194,202,210,218,226,234,242,250,258,266,274,282,290,298,306,314,322,330,338,346,354,362,370,378,386,394,402,410,418,426,434,442,450,458,466,474,482,490,498,506,514,522,530,538,546,554,562,570,578,586,594
        ],
        earlyRome: [
          0,140,149,158,167,176,185,194,203,212,221,230,239,248,257,266,275,284,293,302,311,320,329,338,347,356,365,374,383,392,401,410,419,428,437,446,455,464,473,482,491,500,509,518,527,536,545,554,563,572,581,590,599,608,617,626,635,644,653,662
        ],
        romanEmpire: [
          0,150,160,170,180,190,200,210,220,230,240,250,260,270,280,290,300,310,320,330,340,350,360,370,380,390,400,410,420,430,440,450,460,470,480,490,500,510,520,530,540,550,560,570,580,590,600,610,620,630,640,650,660,670,680,690,700,710,720,730
        ],
        byzantineEra: [
          0,160,171,182,193,204,215,226,237,248,259,270,281,292,303,314,325,336,347,358,369,380,391,402,413,424,435,446,457,468,479,490,501,512,523,534,545,556,567,578,589,600,611,622,633,644,655,666,677,688,699,710,721,732,743,754,765,776,787,798
        ],
        ageOfTheFranks: [
          0,170,182,194,206,218,230,242,254,266,278,290,302,314,326,338,350,362,374,386,398,410,422,434,446,458,470,482,494,506,518,530,542,554,566,578,590,602,614,626,638,650,662,674,686,698,710,722,734,746,758,770,782,794,806,818,830,842,854,866
        ],
        feudalAge: [
          0,180,193,206,219,232,245,258,271,284,297,310,323,336,349,362,375,388,401,414,427,440,453,466,479,492,505,518,531,544,557,570,583,596,609,622,635,648,661,674,687,700,713,726,739,752,765,778,791,804,817,830,843,856,869,882,895,908,921,934
        ],
        iberianEra: [
          0,190,204,218,232,246,260,274,288,302,316,330,344,358,372,386,400,414,428,442,456,470,484,498,512,526,540,554,568,582,596,610,624,638,652,666,680,694,708,722,736,750,764,778,792,806,820,834,848,862,876,890,904,918,932,946,960,974,988,1002
        ],
        kingdomOfSicily: [
          0,200,215,230,245,260,275,290,305,320,335,350,365,380,395,410,425,440,455,470,485,500,515,530,545,560,575,590,605,620,635,650,665,680,695,710,725,740,755,770,785,800,815,830,845,860,875,890,905,920,935,950,965,980,995,1010,1025,1040,1055,1070
        ],
        highMiddleAges: [
          0,210,226,242,258,274,290,306,322,338,354,370,386,402,418,434,450,466,482,498,514,530,546,562,578,594,610,626,642,658,674,690,706,722,738,754,770,786,802,818,834,850,866,882,898,914,930,946,962,978,994,1010,1026,1042,1058,1074,1090,1106,1122,1138
        ],
        earlyGothicEra: [
          0,220,237,254,271,288,305,322,339,356,373,390,407,424,441,458,475,492,509,526,543,560,577,594,611,628,645,662,679,696,713,730,747,764,781,798,815,832,849,866,883,900,917,934,951,968,985,1002,1019,1036,1053,1070,1087,1104,1121,1138,1155,1172,1189,1206
        ],
        lateGothicEra: [
          0,230,248,266,284,302,320,338,356,374,392,410,428,446,464,482,500,518,536,554,572,590,608,626,644,662,680,698,716,734,752,770,788,806,824,842,860,878,896,914,932,950,968,986,1004,1022,1040,1058,1076,1094,1112,1130,1148,1166,1184,1202,1220,1238,1256,1274
        ]
      }).withOutput(ProductionOutputType.CURRENT_ERA_SECONDARY_GOODS),
    ),
  ]),
};

export default AncientLibrary;
